import { FiMap, FiList } from 'react-icons/fi';
import { IoMdOptions } from 'react-icons/io';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface StyledProps {
  isVisible: boolean;
}

export const MapButton = styled.div.attrs<any, StyledProps>((): any => ({}))`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 24px 12px;
  padding-left: 20px;
  pointer-events: ${({ isVisible }) => (isVisible ? 'inherit' : 'none')};
  display: ${({ isVisible }) => (isVisible ? 'inherit' : 'none')};
`;

export const MapLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.primaryBackgroundColor};
  margin-right: 13px;
  padding-left: 4px;
`;

export const MapIcon = styled(FiMap)`
  font-size: 18px;
  color: ${({ theme }) => theme.hotelsList.icon} !important;
`;

export const ListIcon = styled(FiList)`
  font-size: 18px;
  color: ${({ theme }) => theme.hotelsList.icon} !important;
`;

export const FilterIconContainer = styled.span`
  line-height: 14px;
`;

export const FilterIcon = styled(IoMdOptions)`
  font-size: 16px;
  color: ${({ theme }) => theme.primaryBackgroundColor} !important;
`;

export const Container = styled.div`
  position: fixed;
  z-index: 2;
  width: fit-content;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 5%;
  left: 50%;
  transform: translate(-50%);
`;

export const Filter: any = styled.span`
  display: flex;
  height: 56px;
  padding: 0 24px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  align-items: center;
  border-radius: 28px;
  background-color: ${ColorPalette.HEX.White};
  justify-content: space-around;
  box-shadow: 0 2px 16px 0 rgba(${ColorPalette.RGB.Black}, 0.3);

  & > div {
    display: flex;
    width: 50%;
    align-items: center;
    justify-content: center;
  }
`;

Filter.Label = styled.span`
  font-size: 12px;
  margin: 0 4px;
  color: ${({ theme }) => theme.primaryBackgroundColor};
`;

Filter.Divider = styled.span`
  width: 1px;
  height: 36px;
  background: ${({ theme }) => theme.flightsList.filterDivider};
`;
